import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgEnqueteMobiel = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#60D15D"
      d="M27.44 6H12.56a.56.56 0 0 0-.56.56v26.88c0 .31.25.56.56.56h14.88c.31 0 .56-.25.56-.56V6.56a.56.56 0 0 0-.56-.56"
    />
    <path
      fill="#ECF9EC"
      d="M26 8H14v21.86h12z"
    />
    <path
      fill="#B3E9B1"
      d="M18.5 18H16v2.5h2.5zM18.5 24H16v2.5h2.5zM21.52 31h-3.04a1 1 0 1 0 0 2h3.04a1 1 0 1 0 0-2"
    />
    <path
      fill="#00215B"
      fillRule="evenodd"
      d="m21.678 16.36-4.496 4.353-2.217-2.372.73-.683 1.523 1.629 3.764-3.646z"
      clipRule="evenodd"
    />
    <path
      fill="#60D15D"
      fillRule="evenodd"
      d="M24 20.5h-4.69v-1H24zM24 26.5h-4.69v-1H24zM24 10.37h-8v-1h8zM20 12.37h-4v-1h4z"
      clipRule="evenodd"
    />
    <path
      fill="#00215B"
      fillRule="evenodd"
      d="m21.678 22.36-4.496 4.353-2.217-2.372.73-.683 1.523 1.629 3.764-3.646z"
      clipRule="evenodd"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgEnqueteMobiel);

export default ForwardRef;
